import {defineComponent} from 'vue';

export default defineComponent({
    name: 'AegSessionStatusPopover',
    setup() {
        return {};
    }
});
